import React, { FC } from 'react';
import { GestureResponderEvent, View } from 'react-native';
import { TFunction } from 'i18next';

import { alertsTestIDs } from '@constants';

import { styles } from './styles';

import { VOD_Icons } from '../../../../assets/icons/vod/index';
import { TWCButton } from '../../../focusable/TWCButton/TWCButton';
import { TWCText } from '../../../primitives/TWCText/TWCText';

export const LiveANFContent: FC<LiveANFContentProps> = ({
  t,
  nextFocusDown,
  nextFocusUp,
  onPlayPress,
  onCancelPress,
  watchHandle,
  cancelHandle,
}) => (
  <View style={styles.content}>
    <TWCText
      importantForAccessibility={'no'}
      style={styles.liveANFTitleText}
      testID={alertsTestIDs.liveANF.liveTitle}
      variant={'regularText36'}
    >
      {t('headingText')}
    </TWCText>
    <TWCButton
      accessibilityHint={t('watchButtonAccessibilityHint')}
      accessibilityLabel={t('watchButtonAccessibilityLabel')}
      icon={VOD_Icons.play}
      iconFocused={VOD_Icons.playFocused}
      nextFocusDown={nextFocusDown}
      nextFocusLeft={watchHandle}
      nextFocusRight={watchHandle}
      nextFocusUp={watchHandle}
      style={styles.watchButton}
      testID={alertsTestIDs.liveANF.watchNowButton}
      title={t('watchButtonText')}
      onPress={onPlayPress}
    />
    <TWCButton
      accessibilityHint={t('cancelButtonAccessibilityHint')}
      accessibilityLabel={t('cancelButtonAccessibilityLabel')}
      nextFocusDown={cancelHandle}
      nextFocusLeft={cancelHandle}
      nextFocusRight={cancelHandle}
      nextFocusUp={nextFocusUp}
      testID={alertsTestIDs.liveANF.cancelButton}
      title={t('cancelButtonText')}
      onPress={onCancelPress}
    />
  </View>
);

type LiveANFContentProps = {
  t: TFunction;
  nextFocusDown?: number | null;
  nextFocusUp?: number | null;
  onPlayPress?: (event: GestureResponderEvent) => void;
  onCancelPress?: (event: GestureResponderEvent) => void;
  watchHandle?: number | null;
  cancelHandle?: number | null;
};
